var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetBanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11131 12.0662H3.62239V20.933H6.11131V12.0662ZM13.5781 12.0662H11.0892V20.933H13.5781V12.0662ZM24.156 23.4663H0.51123V25.9997H24.156V23.4663ZM21.0448 12.0662H18.5559V20.933H21.0448V12.0662ZM12.3336 3.52872L18.8173 6.99944H5.84997L12.3336 3.52872ZM12.3336 0.666016L0.51123 6.99944V9.53281H24.156V6.99944L12.3336 0.666016Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetBanking);
export default __webpack_public_path__ + "static/media/net-banking.62d6c166638a9749a981122fc3746455.svg";
export { ForwardRef as ReactComponent };